import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Container, Typography, Link as MuiLink } from '@mui/material';

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="md" sx={{ my: 4, px: 2 }}>
      {/* Back Button */}
      <Box sx={{ display: 'flex', justifyContent: 'flex-start', mb: 3 }}>
        <Button variant="contained" onClick={() => navigate(-1)}>
          ← Back
        </Button>
      </Box>

      {/* Title and Last Updated */}
      <Typography variant="h3" component="h1" gutterBottom>
        Privacy Policy
      </Typography>
      <Typography variant="subtitle1" gutterBottom>
        <strong>Last Updated:</strong> 31.03.2025
      </Typography>

      {/* Introduction */}
      <Typography variant="body1">
        Medicheck, operated by Vision Grid, is committed to protecting your privacy. This Privacy Policy outlines how we collect, use, and safeguard your personal information when you subscribe to and use our platform at{' '}
        <MuiLink href="http://www.medicheck.lk/" target="_blank" rel="noopener noreferrer">
          www.medicheck.lk
        </MuiLink>.
      </Typography>

      {/* Information We Collect */}
      <Typography variant="h5" component="h2" sx={{ mt: 8, mb: 2 }}>
        Information We Collect
      </Typography>
      <Typography variant="body1" sx={{ mb: 1 }}>
        a) <strong>Personal Information:</strong> We may collect personal identification information (such as your name, email address, and phone number) provided voluntarily by you during the registration or subscription processes.
      </Typography>
      <Typography variant="body1" sx={{ mb: 1 }}>
        b) <strong>Payment Information:</strong> Payment and billing information necessary to process your orders, including credit card details, which are securely handled by trusted third-party payment processors. Medicheck does not store or have access to your complete credit or debit card details.
      </Typography>
      <Typography variant="body1" sx={{ mb: 1 }}>
        c) <strong>Usage Data:</strong> We automatically collect information about how you use Medicheck, including your IP address, browser type, device information, visited pages, and usage patterns etc. This helps us enhance and improve our platform.
      </Typography>
      <Typography variant="body1" sx={{ mb: 1 }}>
        d) <strong>Cookies and Tracking Technologies:</strong> We use cookies and similar technologies to enhance your browsing experience, analyze website traffic, and gather information about your preferences and interactions with our website. You have the option to disable cookies through your browser settings, but this may limit certain features and functionality of our website.
      </Typography>

      {/* How We Use Your Information */}
      <Typography variant="h5" component="h2" sx={{ mt: 8, mb: 2  }}>
        How We Use Your Information
      </Typography>
      <Typography variant="body1" sx={{ mb: 1 }}>
        a) To create, manage, and maintain your account and subscription.
      </Typography>
      <Typography variant="body1" sx={{ mb: 1 }}>
        b) To securely process payments and manage subscription billing via a third-party payment processor.
      </Typography>
      <Typography variant="body1" sx={{ mb: 1 }}>
        c) To communicate essential account information, billing confirmations, service notices, and updates.
      </Typography>
      <Typography variant="body1" sx={{ mb: 1 }}>
        d) To improve and enhance the quality and functionality of Medicheck based on user feedback and usage patterns.
      </Typography>
      <Typography variant="body1" sx={{ mb: 1 }}>
        e) To detect and prevent fraud, unauthorized activities, and abuse of our website.
      </Typography>

      {/* Sharing Your Information */}
      <Typography variant="h5" component="h2" sx={{ mt: 8, mb: 2  }}>
        Sharing Your Information
      </Typography>
      <Typography variant="body1" sx={{ mb: 1 }}>
        a) <strong>Trusted Service Providers:</strong> We may share your information with third-party service providers who assist us in operating our website and processing payments. These providers are contractually obligated to handle your data securely and confidentially.
      </Typography>
      <Typography variant="body1" sx={{ mb: 1 }}>
        b) <strong>Legal requirements:</strong> We may disclose your information if required to do so by law or in response to valid legal requests or orders.
      </Typography>

      {/* Data Security */}
      <Typography variant="h5" component="h2" sx={{ mt: 8, mb: 2  }}>
        Data Security
      </Typography>
      <Typography variant="body1" sx={{ mb: 1 }}>
        We implement industry-standard security measures to protect your personal information from unauthorized access, alteration, disclosure, or destruction. However, please be aware that no method of transmission over the internet or electronic storage is 100% secure, and we cannot guarantee absolute security.
      </Typography>

      {/* Data Retention */}
      <Typography variant="h5" component="h2" sx={{ mt: 8, mb: 2  }}>
        Data Retention
      </Typography>
      <Typography variant="body1" sx={{ mb: 1 }}>
        Your personal data will be retained as long as your subscription is active, and thereafter only as required by law, for compliance, or operational purposes.
      </Typography>


      {/* Changes to This Privacy Policy */}
      <Typography variant="h5" component="h2" sx={{ mt: 8, mb: 2  }}>
        Changes to This Privacy Policy
      </Typography>
      <Typography variant="body1" sx={{ mb: 1 }}>
        We reserve the right to update or modify this Privacy Policy at any time. Changes will be posted clearly on our website along with an updated "Last Updated" date. Your continued use of Medicheck indicates your acceptance of the updated policy.
      </Typography>

      {/* Contact Us */}
      <Typography variant="h5" component="h2" sx={{ mt: 8, mb: 2  }}>
        Contact Us
      </Typography>
      <Typography variant="body1" sx={{ mb: 1 }}>
        If you have questions, concerns, or requests regarding your privacy or this policy, please contact us: support@medicheck.lk
      </Typography>
    </Container>
  );
};

export default PrivacyPolicy;
